import { storage } from 'APP/packages/storage';

export function changeAppLanguage(language: string): boolean {
  try {
    storage.language.set(language);
    window.location.reload();

    return true;
  } catch {
    return false;
  }
}
